module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/tools/touchspin/touchspin.component.scss
// module id = ./src/app/components/tools/touchspin/touchspin.component.scss
// module chunks = main